import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import './TermsModal.css';

interface TermsModalProps {
  isOpen: boolean;
  onAccept: () => void;
  onDecline?: () => void; // optional; not shown in UI but kept for compatibility
}

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onAccept, onDecline }) => {
  const [checked, setChecked] = useState(false);
  const [showError, setShowError] = useState(false);

  useEffect(() => {
    if (!isOpen) return;
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prevOverflow;
    };
  }, [isOpen]);

  useEffect(() => {
    if (!isOpen) {
      setChecked(false);
      setShowError(false);
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleEnter = () => {
    if (!checked) {
      setShowError(true);
      return;
    }
    onAccept();
  };

  return createPortal(
    <div className="tc-modal-overlay" role="dialog" aria-modal="true" aria-labelledby="tc-modal-title">
      <div className="tc-modal" role="document">
        {onDecline && (
          <button className="tc-close" aria-label="Close" onClick={onDecline}>✕</button>
        )}
 
        <div className="tc-title-bar">
          <span className="tc-icon" aria-hidden="true">⚠️</span>
          <h2 id="tc-modal-title" className="tc-title">Warning</h2>
        </div>
 
        <div className="tc-divider" />
 
        <div className="tc-content">
          <p>
            E‑Pay Dollar Protocol is a fully decentralized stablecoin protocol. No representation or warranty is made
            concerning any aspect of the E‑Pay Dollar Protocol, including its suitability, quality, availability,
            accessibility, accuracy or safety. As more fully explained in the Terms of Use (available
            &nbsp;<a href="/docs/terms-of-use" className="tc-link">here</a>), your access to and use of the E‑Pay Dollar Protocol
            through this interface is entirely at your own risk and could lead to substantial losses. You take full
            responsibility for your use of the interface, and acknowledge that you use it on the basis of your own enquiry,
            without solicitation or inducement by Contributors (as defined in the Terms of Use).
          </p>
 
          <p>
            This interface is not available to residents of Belarus, the Central African Republic, the Democratic Republic of
            Congo, the Democratic People’s Republic of Korea, the Crimea region of Ukraine, Cuba, Iran, Libya, Somalia, Sudan,
            South Sudan, Syria, the USA, the United Kingdom, Yemen, and Zimbabwe or any other jurisdiction in which accessing
            or using the E‑Pay Dollar Protocol is prohibited (“Prohibited Jurisdictions”). In using this interface, you confirm
            that you are not located in, incorporated or otherwise established in, or a citizen or resident of, a Prohibited
            Jurisdiction.
          </p>
 
          <p>
            References to the USD.P stablecoin are for informational purposes only and do not constitute investment advice.
            Use of USD.P may be subject to additional terms and applicable laws and regulations.
          </p>
        </div>
 
        <div className="tc-consent">
          <label className="tc-checkbox">
            <input
              type="checkbox"
              checked={checked}
              onChange={(e) => { setChecked(e.target.checked); if (e.target.checked) setShowError(false); }}
              aria-describedby="tc-consent-help"
            />
            <span>
              I confirm that I have read, understand and accept the <a href="/docs/terms-of-use" className="tc-link">Terms of Use</a>
            </span>
          </label>
          {showError && !checked && (
            <div id="tc-consent-help" className="tc-error">Please accept the Terms of Use to continue.</div>
          )}
        </div>
 
        <div className="tc-actions tc-actions-left">
          <button
            className="tc-button tc-primary"
            onClick={handleEnter}
            disabled={!checked}
            aria-disabled={!checked}
          >
            Enter
          </button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default TermsModal;